import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './testimonial17.css'

const Testimonial17 = (props) => {
  return (
    <div className={`thq-section-padding ${props.rootClassName} `}>
      <div className="testimonial17-max-width thq-section-max-width">
        <div className="testimonial17-container10">
          <h2 className="thq-heading-2">
            {props.heading1 ?? (
              <Fragment>
                <span className="testimonial17-text35">Testimonials</span>
              </Fragment>
            )}
          </h2>
          <span className="testimonial17-text11 thq-body-small">
            {props.content1 ?? (
              <Fragment>
                <span className="testimonial17-text24">
                  Read what our clients have to say about their experience with
                  our property listing services.
                </span>
              </Fragment>
            )}
          </span>
        </div>
        <div className="thq-grid-2">
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div
                data-animated="true"
                className="thq-card testimonial17-card1"
              >
                <div className="testimonial17-container12">
                  <img
                    alt={props.author1Alt}
                    src={props.author1Src}
                    className="testimonial17-image1"
                  />
                  <div className="testimonial17-container13">
                    <strong className="thq-body-large">
                      {props.author1Name ?? (
                        <Fragment>
                          <span className="testimonial17-text32">John Doe</span>
                        </Fragment>
                      )}
                    </strong>
                    <span className="thq-body-small">
                      {props.author1Position ?? (
                        <Fragment>
                          <span className="testimonial17-text26">
                            Real Estate Investor
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
                <span className="testimonial17-text14 thq-body-small">
                  {props.review1 ?? (
                    <Fragment>
                      <span className="testimonial17-text37">
                        I have been using this platform for a while now, and it
                        has made property hunting so much easier for me. The
                        virtual tours are a game-changer!
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div
                data-animated="true"
                className="thq-card testimonial17-card2"
              >
                <div className="testimonial17-container14">
                  <img
                    alt={props.author2Alt}
                    src={props.author2Src}
                    className="testimonial17-image2"
                  />
                  <div className="testimonial17-container15">
                    <strong className="thq-body-large">
                      {props.author2Name ?? (
                        <Fragment>
                          <span className="testimonial17-text31">
                            Jane Smith
                          </span>
                        </Fragment>
                      )}
                    </strong>
                    <span className="thq-body-small">
                      {props.author2Position ?? (
                        <Fragment>
                          <span className="testimonial17-text33">
                            Home Buyer
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
                <span className="testimonial17-text17 thq-body-small">
                  {props.review2 ?? (
                    <Fragment>
                      <span className="testimonial17-text29">
                        I found my dream home through this site, and the market
                        insights provided were invaluable in making an informed
                        decision. Highly recommended!
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div
                data-animated="true"
                className="thq-card testimonial17-card3"
              >
                <div className="testimonial17-container16">
                  <img
                    alt={props.author3Alt}
                    src={props.author3Src}
                    className="testimonial17-image3"
                  />
                  <div className="testimonial17-container17">
                    <strong className="thq-body-large">
                      {props.author3Name ?? (
                        <Fragment>
                          <span className="testimonial17-text30">
                            David Johnson
                          </span>
                        </Fragment>
                      )}
                    </strong>
                    <span className="thq-body-small">
                      {props.author3Position ?? (
                        <Fragment>
                          <span className="testimonial17-text27">
                            Property Developer
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
                <span className="testimonial17-text20 thq-body-small">
                  {props.review3 ?? (
                    <Fragment>
                      <span className="testimonial17-text36">
                        As a property developer, having a platform that
                        showcases my listings with virtual tours is fantastic.
                        It has increased the visibility of my properties.
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div
                data-animated="true"
                className="thq-card testimonial17-card4"
              >
                <div className="testimonial17-container18">
                  <img
                    alt={props.author4Alt}
                    src={props.author4Src}
                    className="testimonial17-image4"
                  />
                  <div className="testimonial17-container19">
                    <strong className="thq-body-large">
                      {props.author4Name ?? (
                        <Fragment>
                          <span className="testimonial17-text34">
                            Sarah Brown
                          </span>
                        </Fragment>
                      )}
                    </strong>
                    <span className="thq-body-small">
                      {props.author4Position ?? (
                        <Fragment>
                          <span className="testimonial17-text28">
                            Rental Manager
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
                <span className="testimonial17-text23 thq-body-small">
                  {props.review4 ?? (
                    <Fragment>
                      <span className="testimonial17-text25">
                        Managing rental properties can be challenging, but this
                        site has simplified the process for me. The contact
                        information feature is very convenient.
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Testimonial17.defaultProps = {
  author3Alt: 'David Johnson - Property Developer',
  content1: undefined,
  author2Src:
    'https://images.unsplash.com/photo-1508440767412-59ce0b206bbc?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczNjI1NzQ2NXw&ixlib=rb-4.0.3&q=80&w=1080',
  review4: undefined,
  author2Alt: 'Jane Smith - Home Buyer',
  author1Position: undefined,
  author3Position: undefined,
  author1Alt: 'John Doe - Real Estate Investor',
  author4Position: undefined,
  review2: undefined,
  author3Name: undefined,
  author4Src:
    'https://images.unsplash.com/photo-1496545087308-51ec893e6bbc?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczNjI1NzQ2NHw&ixlib=rb-4.0.3&q=80&w=1080',
  author3Src:
    'https://images.unsplash.com/photo-1470406852800-b97e5d92e2aa?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczNjI1NzQ2NXw&ixlib=rb-4.0.3&q=80&w=1080',
  author2Name: undefined,
  author1Src:
    'https://images.unsplash.com/photo-1528713221337-4c0148dc227c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczNjI1NzQ2NHw&ixlib=rb-4.0.3&q=80&w=1080',
  author4Alt: 'Sarah Brown - Rental Manager',
  author1Name: undefined,
  rootClassName: '',
  author2Position: undefined,
  author4Name: undefined,
  heading1: undefined,
  review3: undefined,
  review1: undefined,
}

Testimonial17.propTypes = {
  author3Alt: PropTypes.string,
  content1: PropTypes.element,
  author2Src: PropTypes.string,
  review4: PropTypes.element,
  author2Alt: PropTypes.string,
  author1Position: PropTypes.element,
  author3Position: PropTypes.element,
  author1Alt: PropTypes.string,
  author4Position: PropTypes.element,
  review2: PropTypes.element,
  author3Name: PropTypes.element,
  author4Src: PropTypes.string,
  author3Src: PropTypes.string,
  author2Name: PropTypes.element,
  author1Src: PropTypes.string,
  author4Alt: PropTypes.string,
  author1Name: PropTypes.element,
  rootClassName: PropTypes.string,
  author2Position: PropTypes.element,
  author4Name: PropTypes.element,
  heading1: PropTypes.element,
  review3: PropTypes.element,
  review1: PropTypes.element,
}

export default Testimonial17
